import React from "react";
import {Button} from "@material-ui/core";
import TabLabel from "../../tabs/TabLabel";

const ButtonIconLeft = (props) => {
    return (
        <Button color="primary" onClick={props.handleClick} style={props.styles} disabled={props.disabled}>
            {props.icon} {props.title}
        </Button>
)
}

TabLabel.defaultProps = {
    disabled: false
};

export default ButtonIconLeft;
